import * as React from 'react';

export default function EnterpriseMobileLoggedInMainNav() {
  return <div>EnterpriseMobileLoggedInMainNav</div>;
}
